<template>
    <div id="HomeDiv">
        <HeaderVue isHeader="true"/>
                <!-- BEGIN banner-section -->
        <div class="banner-section">
            <div class="container">
                <div class="row">
                    <div class="col-12">
                        <div class="banner-text">
                            <h1>Your blood tests, Your choice of labs, at Your home</h1>
                            <h4>Affordable tests at great convenience</h4>
                            <p class="black-color text-center mb-1 mt-3 font-weight-bold">Our service is currently in Chennai & Bengaluru</p>
                            <div class="banner-fields">
                                {{query.locationName}}
                                <button class="btn btn-lg btn-primary full-width mt-3" ref="pincodeSubmit" type="button" v-on:click="$router.push({ path: '/lab' })">
                                Book Test
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="container">
                <div class="row mt-3">
                    <div class="col-12">
                        <div id="carouselExampleControls" class="carousel slide" data-ride="carousel">
                            <div class="carousel-inner">
                                <div class="carousel-item active">
                                    <img src="static/images/banner.svg" class="d-block w-100" alt="">
                                </div>
                                <div class="carousel-item">
                                    <img class="d-block w-100" src="static/images/banner-old.svg" alt="Second slide">
                                </div>
                            </div>
                            <a class="carousel-control-prev" href="#carouselExampleControls" role="button" data-slide="prev">
                                <span class="carousel-control-prev-icon" aria-hidden="true"><i class="fa fa-angle-double-left"></i></span>
                                <span class="sr-only">Previous</span>
                            </a>
                            <a class="carousel-control-next" href="#carouselExampleControls" role="button" data-slide="next">
                                <span class="carousel-control-next-icon" aria-hidden="true"><i class="fa fa-angle-double-right"></i></span>
                                <span class="sr-only">Next</span>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <!--<img src="static/images/banner.png" class="img-fluid section-img banner-img mt-3" alt="">-->
        </div>
                <!-- sample pickup section  -->
        <div class="section">
            <div class="container">
                <div class="row">
                    <div class="col-sm-12">
                        <h2 class="section-title text-center">Why Labotist?</h2>
                        <div class="why-labotist flex-row ">
                            <div class="future-list flex-nowrap flex-column">
                                <span class="sprites sprite-pickup align-center"></span>
                                <p>Free Home
                                    <br> Sample Pickup</p>
                            </div>
                            <div class="future-list flex-column">
                                <span class="sprites sprite-phlebotomists align-center"></span>
                                <p>Trained
                                    <br> Phlebotomists</p>
                            </div>
                            <div class="future-list flex-column">
                                <span class="sprites sprite-shield align-center"></span>
                                <p>Technology enabled & safe
                                    <br> sample collection process</p>
                            </div>
                            <div class="future-list">
                                <span class="sprites sprite-star align-center"></span>
                                <p>Know
                                    <br> your labs better</p>
                            </div>
                            <div class="future-list">
                                <span class="sprites sprite-mobile align-center"></span>
                                <p>Get
                                    <br> Online Reports</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
                <!-- list of labotist description -->
        <div class="blue-bg">
            <div class="section">
                <div class="container">
                    <div class="row">
                        <div class="col-sm-12">
                            <h2 class="section-title">We created a specially designed box and universal kit for you to ensure accurate results</h2>
                            <img src="static/images/kit.svg" class="img-fluid section-img kit-img" alt="">
                            <ul class="kit-list">
                                <li>Disposable</li>
                                <li>Pre-bar coded tubes</li>
                                <li>Hygienic sample draw accessories</li>
                                <li>Insulated box for safe transportation of samples</li>
                                <li>Temperature controlled to ensure sample quality</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>

            <div class="section">
                <div class="container">
                    <div class="row">
                        <div class="col-sm-12">
                            <h2 class="section-title text-center">How Labotist Works?</h2>
                        </div>
                    </div>
                    <div class="flex-row labotist-work">
                        <div class="flex-column">
                            <div class="white-box ml-0">
                                <div class="white-content">
                                    <span class="sprites sprite-one"></span>
                                    <h5>Choose test and select lab</h5>
                                    <p>Select the right test and the best lab based on quality, turn around time, method of
                                        testing & price, and book your test digitally </p>
                                </div>
                            </div>
                        </div>
                        <div class="flex-column">
                            <div class="white-box">
                                <div class="white-content">
                                    <span class="sprites sprite-two"></span>
                                    <h5>Sample collected at home</h5>
                                    <p>A trained phlebotomist will come to your home at the scheduled time to collect the sample in a safe & hygienic method and deliver it to the choosen lab making it very convenient for you.</p>
                                </div>
                            </div>
                        </div>
                        <div class="flex-column">   
                            <div class="white-box">
                                <div class="white-content">
                                    <span class="sprites sprite-three"></span>
                                    <h5>Safe, Secure & Accurate</h5>
                                    <p>The technology driven sample collection process and transportation of samples in a specially designed box, ensures superior sample quality, enabling accurate results.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
                <!-- personal Openion section -->
        <div class="green-bg">
            <div class="section dashboard-online">
                <div class="container">
                    <div class="row">
                        <div class="col-sm-5">
                            <h2 class="section-title">Your personal
                                <br> dashboard online</h2>
                            <p class="theme-lineheight">All lab reports, irrespective of the lab at which you get your tests done, will be stored under
                                one registered account securely. You will also be able to manage your records or that of
                                family members under one account. Labotist provides easy access to health records and history whenever and whereever needed.</p>
                        </div>
                        <div class="col-sm-7">
                            <img src="static/images/responsive.svg"  class="img-fluid full-width section-img responsive-img" alt="">
                        </div>
                    </div>
                </div>
            </div>

            <div class="section">
                <div class="container">
                    <div class="row">
                        <div class="col-sm-12">
                            <h2 class="section-title text-center">What our customer say</h2>
                        </div>
                    </div>
                    <div class="d-flex testimonial-list">
                        <div class="flex-column">
                            <div class="testimonial-box">
                                <p>The lab test search and selection of labs was very simple. I was able to make a well informed decision on the lab instead of by default opting to go the nearest one or the one which my doctor asks me to go</p>
                            </div>
                            <div class="testimonial-profile clearfix">
                                <div class="testimonial-dp" style="background-image: url(static/images/kumaresh.png); background-size: 100%;">
                                </div>
                                <h5>Kumaresh</h5>
                                <p>IT Engineer</p>
                            </div>
                        </div>
                        <div class="flex-column">
                            <div class="testimonial-box">
                                <p>You guys rock. Such a convenient way to research, order and get samples collected and delivered professionally..all just through a few clicks. A great experience.</p>
                            </div>
                            <div class="testimonial-profile clearfix">
                                <div class="testimonial-dp" style="background-image: url(static/images/imran.png); background-size: 100%;">
                                
                                </div>
                                <h5>Imran</h5>
                                <p>Director of Photography</p>
                            </div>
                        </div>
                        <div class="flex-column">
                            <div class="testimonial-box">
                                <p>First time I ever felt pampered during the blood draw process :). Quick, easy & hygienic. Technology working at its best to ensure safety, quality and convenience.</p>
                            </div>
                            <div class="testimonial-profile clearfix">
                                <div class="testimonial-dp" style="background-image: url(static/images/hemavathy.png); background-size: 100%;">

                                </div>
                                <h5>Hemavathy</h5>
                                <p>Housewife</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="container">
                    <div class="row mt-3">
                        <div class="col-sm-12">
                            <h2 class="section-title text-center">Our Lab Partners</h2>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12">
                            <div id="carouselLabPartners" class="carousel slide" data-ride="carousel">
                                <div class="carousel-inner">
                                    <div class="carousel-item active">
                                        <img src="static/images/client/medall.jpg" class="d-block w-75 align-center" alt="Medall Health Care Pvt Ltd">
                                    </div>
                                    <div class="carousel-item">
                                        <img src="static/images/client/metroplis.png" class="d-block w-75 align-center" alt="Lister Metropolis Healthcare Limited">
                                    </div>
                                    <div class="carousel-item">
                                        <img src="static/images/client/bioline.jpg" class="d-block w-75 align-center" alt="Bio Line Laboratory">
                                    </div>
                                    <div class="carousel-item">
                                        <img src="static/images/client/techmed.jpg" class="d-block w-75 align-center" alt="Techmed Health Centre & Diagnostic">
                                    </div>
                                    <div class="carousel-item">
                                        <img src="static/images/client/srl.png" class="d-block w-75 align-center" alt="Specialtys Medical Diagnostic(SRL Diagnostics)">
                                    </div>
                                    <div class="carousel-item">
                                        <img src="static/images/client/vrr.jpg" class="d-block w-75 align-center" alt="VRR Diagnostics">
                                    </div>
                                    <div class="carousel-item">
                                        <img src="static/images/client/medcis.png" class="d-block w-75 align-center" alt="Medcis Pathlabs India Pvt. Ltd">
                                    </div>
                                    <div class="carousel-item">
                                        <img src="static/images/client/pathcare.jpg" class="d-block w-75 align-center" alt="Path Care Labs Pvt. Ltd">
                                    </div>
                                    <div class="carousel-item">
                                        <img src="static/images/client/aarthi.jpg" class="d-block w-75 align-center" alt="Aarthi Scans And Labs">
                                    </div>
                                    <div class="carousel-item">
                                        <img src="static/images/client/primex.png" class="d-block w-75 align-center" alt="Primex Scans and Labs">
                                    </div>
                                    <div class="carousel-item">
                                        <img src="static/images/client/microbiological.jpg" class="d-block w-75 align-center" alt="Microbiological Laboratory">
                                    </div>
                                    <div class="carousel-item">
                                        <img src="static/images/client/hitech.jpg" class="d-block w-75 align-center" alt="Hitech Diagnostic Centre">
                                    </div>
                                    <div class="carousel-item">
                                        <img src="static/images/client/asian.jpg" class="d-block w-75 align-center" alt="Asian Diagnostics">
                                    </div>
                                    <div class="carousel-item">
                                        <img src="static/images/client/diagnolabs.jpg" class="d-block w-75 align-center" alt="Diagno labs Pvt Ltd">
                                    </div>
                                </div>
                                <a class="carousel-control-prev" href="#carouselLabPartners" role="button" data-slide="prev">
                                    <span class="carousel-control-prev-icon" aria-hidden="true"><i class="fa fa-angle-double-left"></i></span>
                                    <span class="sr-only">Previous</span>
                                </a>
                                <a class="carousel-control-next" href="#carouselLabPartners" role="button" data-slide="next">
                                    <span class="carousel-control-next-icon" aria-hidden="true"><i class="fa fa-angle-double-right"></i></span>
                                    <span class="sr-only">Next</span>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <FooterVue foot= "true" />
    </div>
</template>

<script>
// import Login from '@/components/Login'
import HeaderVue from '@/components/mobile/Header'
import FooterVue from '@/components/mobile/Footer'
import Vue from 'vue'

export default {
  name: 'Home',
  components: {
    HeaderVue,
    FooterVue
  },
  beforeCreate () {
    this.query = this.$localStorage.get('location')
  },
  created () {
    setTimeout(function () {
      $("#carouselExampleControls").carousel()
      $("#carouselLabPartners").carousel()
    }, 1000)
  },
  data () {
    return {
      onBlurKey: 'none',
      address: '',
      query: this.$localStorage.get('location') ? this.$localStorage.get('location').locationName + '-' + this.$localStorage.get('location').locationZipCode : '',
      items: [],
      selectedLocation: this.$localStorage.get('location') ? this.$localStorage.get('location') : undefined,
      selectedPincode: this.$localStorage.get('pincode') ? this.$localStorage.get('pincode') : undefined,
      locationObj: null
    }
  },
  methods: {
    goTest: function () {
      this.query = this.selectedLocation ? this.selectedLocation.locationName + '-' + this.selectedLocation.locationZipCode : ''
      if (!this.selectedLocation) {
        return false
      }
      this.$localStorage.set('location', this.selectedLocation, 0)
      this.$localStorage.set('pincode', this.selectedLocation.locationZipCode, 0)
      Vue.analytics.fbq.event('ViewContent', {
        content_ids: this.selectedLocation.locationId,
        content_name: this.selectedLocation.locationZipCode,
        contents: {id: this.selectedLocation.locationId, location: this.selectedLocation.locationName, zipcode: this.selectedLocation.locationZipCode},
        content_type: 'PINCODE_ENTERED'
      })
      this.$router.push({ path: '/lab' })
    },
    searchLocation: function (event) {
      if (event.key === 'Control' || event.key === 'Tab') {
        return false
      }
      this.onBlurKey = 'block'
      this.selectedLocation = undefined
      this.$localStorage.remove('location')
      this.$localStorage.remove('pincode')
      if (this.query.length < 3) {
        this.onBlurKey = 'none'
        this.items = []
        return false
      }
      try {
        if (this.$localStorage.get('access_token') !== '') {
          var data = {
            'keyword': this.query
          }
          Promise.resolve(this.$POST('patient/searchLocation', data)).then(function (res) {
            console.log(res)
            if (res.response_code === 0) {
              this.items = res.response
            }
          }.bind(this)).catch(function (err) {
            console.error(err)
          })
        }
      } catch (e) {
        console.error(e)
      }
    },
    closeBlock: function () {
      setTimeout(function () {
        this.onBlurKey = 'none'
      }.bind(this), 300)
    },
    selectLocation: function (event, obj) {
      this.selectedLocation = undefined
      this.selectedLocation = obj
      this.selectedPincode = obj.locationZipCode
      this.query = obj.locationName + '-' + obj.locationZipCode
      this.items = []
      this.onBlurKey = 'none'
      setTimeout(function () {
        this.$refs.pincodeSubmit.focus()
      }.bind(this), 300)
    }
  },
  watch: {
    address: function (val, oldVal) {
      console.log('new: %s, old: %s', val, oldVal)
    }
  },
  mounted () {
    this.$hidePageLoading()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.btn {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/mobile/Home.vue